const _ = require('lodash')

export const snakeToHumanReadable = (snakeString: string) => {
  return _.startCase(_.lowerCase(snakeString))
}
